import { Component, Input, OnInit } from "@angular/core";
import { TargetStruct } from "../../../entities/firmware/target.struct";

@Component({
  selector: "embed-firmware-target",
  template: `
    <firmware-target-widget
      [entity]="entity"
      [options]="options"
      [layout]="layout"
    ></firmware-target-widget>
  `,
})
export class EmbedFirmwareTarget implements OnInit {
  @Input() entity: TargetStruct = null;
  @Input() options: any = null;
  @Input() layout: string = null;

  public criteria_types = [];

  constructor() {}

  ngOnInit(): void {}
}
